import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import Button from '../../../_custom/Button/Button';
import styles from './CompactDownloadButton.module.scss';

interface CompactDownloadButtonProps {
    onClick: () => void;
    expanded: boolean;
    disabled?: boolean;
}

function CompactDownloadButton({ onClick, expanded, disabled }: CompactDownloadButtonProps) {
    return (
        <Button
            type="button"
            text={<FileDownloadOutlinedIcon className={styles.icon} aria-hidden />}
            className={styles.compactDownload}
            onClick={onClick}
            disabled={disabled}
            aria-label="Download"
            aria-haspopup="true"
            aria-expanded={expanded}
        />
    );
}

export default CompactDownloadButton;
